import React, { useState, useEffect } from 'react'
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { apiCall, fileUpload, getFiles } from '../../../../common/apiconfig';
import { appConfig } from "../../../../../common/constants";
import { checkPermission } from '../../../../../common/utilis';
import { Paginationn } from '../../../../../common/pagination';

import FileViewModal from '../../fileupload/fileviewmodal';
import FileHistory from '../../fileupload/filehistory';
import PdfPreview from '../../fileupload/pdf-preview';
import FileUpdate from '../../fileupload/fileupdate';
import VideoPlayer from 'simple-react-video-thumbnail'

import DotsIcon from '../../../../../img/dots2.svg';
import Download from '../../../../../img/download.png';
import Update from '../../../../../img/update.png';
import User from '../../../../../img/user.png';

import OwnerDetails from '../../fileupload/ownerDetails';
import { ViewRow } from '../../../formElements';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';


import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';


function TabContainer(props) {
  return (
    <Typography component="div" >
      {props.children}
    </Typography>
  );
}
const ViewNotes = (props) => {
  let [isEditCourse, setisEditCourse] = useState(checkPermission('Study_Details_Edit', 'Update'));
  const [value, setValue] = React.useState(0);
  const [offset, setoffset] = useState(0)
  let [apiError, setApiError] = useState(false);
  let [progress, setProgress] = useState(false);
  let [links, setLinks] = useState(props.state.updateNotesData.link)
  let [documents, setDocuments] = useState([])
  let [videos, setVideos] = useState([])
  let [pdfUrl, setPdfUrl] = useState("")
  let [imgUrl, setImgUrl] = useState("")
  const [open, setOpen] = useState(false)
  const [fileData, setFileData] = useState("")
  const [openHistory, setOpenHistory] = useState(false)
  const [openOwner, setOwner] = useState(false)
  const [header, setHeader] = useState('')
  const handleTabsChange = (event, newValue) => {
    setValue(newValue);
  };
  const statusChange = async (event, item, index, type) => {
    console.log(item, "statusChange")
    event.preventDefault()
    // setProgress(true)
    let requestBody = `
  mutation {
    switchStatusSupportDetails(id:"${item.ID}"){
      code
      type
      message
      attributes
    }
  }`;
    requestBody = JSON.stringify({ query: requestBody });
    let res = await apiCall('switchStatusSupportDetails', requestBody);

    if (res && res.data.switchStatusSupportDetails.code === '200') {
      // if (type === "vidoes") {

      // }
      if (type === "documents") {
        let data = [...documents]
        for (var i = 0; i < data.length; i++) {
          if (i == index) {
            data[index]["status"] = (data[i]["status"] == "Y" ? "N" : "Y")
          }
        }
        setDocuments(data)
      } else if (type === "link") {
        let data = [...links]
        for (var i = 0; i < data.length; i++) {
          if (i == index) {
            data[index]["status"] = (data[i]["status"] == "Y" ? "N" : "Y")
          }
        }
        setLinks(data)
      } else {
        let data = [...videos]
        for (var i = 0; i < data.length; i++) {
          if (i == index) {
            data[index]["status"] = (data[i]["status"] == "Y" ? "N" : "Y")
          }
        }
        setVideos(data)
      }
      setProgress(false);
    } else {
      console.log('Error!')
    }


  };
  useEffect(() => {
    props.UpdateFormField({ name: "hidestudytab", value: false })
    return () => {
      props.UpdateFormField({ name: "hidestudytab", value: true })
    }
  }, [])
  const handleClick = async (event) => {
    event.preventDefault();
    props.UpdateFormField({ name: "notes_type", value: props.state.updateNotesData.sn.noteType });
    props.UpdateFormField({ name: "notes_text", value: props.state.updateNotesData.sn.notes });
    props.UpdateFormField({ name: "notes_title", value: props.state.updateNotesData.sn.title });
    props.history.push('/account/studyDetails/site/siteDetails/notes/update');
  }

  const { noteType = "", title
    = '', notes = "",noteId = "" } = props.state.updateNotesData.sn;
  const ID = props.state?.updateNotesData?.document?.ID ?? "";

  const goBack = (event) => {
    event.preventDefault();
    props.history.push('/account/studyDetails/' + props.plural)
  }
  const download = async (e, file) => {
    console.log(e, "fileeee")
    e.preventDefault()
    let res = await getFiles('fileupload', file, "GET");
    if (res.code == 200) {
      var data = JSON.parse(res.attributes)
      window.open(data.URL)
    }
  }
  useEffect(() => {
    if (props.state.updateNotesData.document.length > 0) {
      callDocs(props.state.updateNotesData.document)
    } else {
      props.UpdateFormField({ name: "docUrls", value: [] })
    }
    if (localStorage.getItem("sponsorrole") === "Business User") {
      let data = [...props.state.updateNotesData.link, ...props.state.updateNotesData.document,]
      let obj = data.find(o => o.addedById === localStorage.getItem('loginUserId'));
      console.log(obj, "obj")
      if (obj != undefined) {
        console.log(obj, "objinside")
        //   setisEditCourse("1")
      }

    }
  }, [props.state.updateNotesData.document])


  const callDocs = async (data) => {
    setProgress(true)
    var urldata = data.map(v => ({ ...v, url: "" }))
    for (var i = 0; i < data.length; i++) {
      let res = await getFiles('fileupload', data[i], "GET");
      if (res.code === 200) {
        let data = JSON.parse(res.attributes)
        urldata[i]["url"] = data.URL
      }

    }
    setDocuments(urldata)
    props.UpdateFormField({ name: "docUrls", value: urldata })
    setProgress(false)
  }
  const callVideos = async (data) => {
    setProgress(true)
    var urldata = data.map(v => ({ ...v, url: "" }))
    for (var i = 0; i < data.length; i++) {
      let res = await getFiles('fileupload', data[i], "GET");
      if (res.code === 200) {
        let data = JSON.parse(res.attributes)
        urldata[i]["url"] = data.URL
      }
    }
    setVideos(urldata)
    props.UpdateFormField({ name: "videoUrls", value: urldata })
    setProgress(false)
  }
  const image = (url) => {
    return <img src={url} alt="image" height="75" width="75" />
  }



  const onClose = () => {
    setOpen(false)
    setOpenHistory(false)
    setOwner(false)
  }
  const pdfClick = (e, url) => {
    e.preventDefault()
    setOpen(true)
    setPdfUrl(url)
    setImgUrl("")
  }
  const imgClick = (e, url) => {
    e.preventDefault()
    setOpen(true)
    setImgUrl(url)
    setPdfUrl("")
  }
  let hoverElement = null;
  const hoverEnter = (event, rowData) => {

    hoverElement = event.currentTarget;
    hoverElement.classList.add('showPopover')
  }

  const hoverLeave = (event, rowData) => {
    //hoverElement = event.currentTarget;

    try {
      hoverElement.classList.remove('showPopover')
    } catch (error) {

    }
  }

  const tpopoverEnter = (event, rowData) => {

    //hoverElement = event.currentTarget;
    //hoverElement.classList.add('showPopover')
  }

  const tpopoverLeave = (event, rowData) => {
    //hoverElement = event.currentTarget;
    // hoverElement.classList.remove('showPopover')
  }
  const callUpdateApi = (type, data) => {
    console.log(type, data, "callUpdateApi")
    var newdata = props.state.updateNotesData
    newdata[type] = data
    props.updateNotesData(newdata)
    try {
      hoverElement.classList.remove('showPopover')
    } catch (error) {

    }
  }
  const loading = (status) => {
    setProgress(status)
  }
  const fileversion = (e, data, header) => {
    e.preventDefault()
    setOpenHistory(true)
    setHeader(header)
    setFileData(data)
  }
  const ownerDetailsClick = (e, data) => {
    e.preventDefault()
    setOwner(true)
    setFileData(data)
  }
  String.prototype.limit = function (length) {
    return this.length > length ? (this.substring(0, length) + '...') : this;
  }
  const handlePageClick = (e, offset) => {
    console.log(offset, "offset")
    setoffset(offset)
  }

  return (

    <>
      {progress && <div className="fullScreen">
          <CircularProgress
            disableShrink
            className="progressCircle"
            value={90}
            size={100}
            thickness={1.5}
          />
        </div>}

      {/* <div onClick={goBack} className="subNavText"><img src={BackIcon} alt="goback" />  BACK TO {props.plural} LIST</div><br /> */}

      <div className="">
        {open &&
          <FileViewModal open={open} pdfUrl={pdfUrl} imgUrl={imgUrl} onClose={onClose} />
        }
        {
          openHistory &&
          <FileHistory open={openHistory} onClose={onClose} filedata={fileData} header={header} />
        }
        {
          openOwner &&
          <OwnerDetails open={openOwner} onClose={onClose} filedata={fileData} header="Owner Details" />}
        <form noValidate autoComplete="off" id="addAccountForm" className="row h-form-1">
          <div className="col-md-6">
            <div className="d-flex mt-4 justify-content-end">
              <div class="secondary-header mr-auto">Note Details</div>
              {
                isEditCourse === "1" ?

                  <div className="mt-6">
                    <button onClick={handleClick} className="btn btn-small btn-primary-blue btn-shadow btn-rounded">
                      <i className="fas fa-pencil-alt"></i>&nbsp; EDIT</button>
                  </div>
                  : ""}
            </div>
            <div className="panel-primary-wrap">
              <div className="card">
                <div className="card-body">
                  <div className="card-page-header">NOTE INFORMATION</div>
                  <div className="inputBox">
                    <ViewRow text="Title" textvalue={title} />
                    <ViewRow text="Type of Notes" textvalue={noteType} />
                    <ViewRow text="Notes" textvalue={notes} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-md-6" style={{ display: "flex", alignItems: "center" }}>
              <img src={Img} alt="Image" />
            </div> */}
          <div className="col-md-12">
            <div className="panel-primary-wrap">
              <div className="card">
                <div className="card-body">
                  <div className="card-page-header">NOTE FILES</div>
                  <div className="inputBox">
                    <Tabs
                      value={value}
                      onChange={handleTabsChange}
                      indicatorColor="primary"
                      textColor="primary"

                    >
                      <Tab label="Links" />
                      <Tab label="Documents" />
                      {/* <Tab label="Videos" /> */}
                    </Tabs>
                    {value === 0 && <TabContainer>

                      <>
                        {/* <div style={{ fontSize: "14px", fontWeight: "700", color: "#626262", marginLeft: "5px" }}>Links</div> */}
                        {/* <div className="inputBox"> */}
                        {props.state.updateNotesData.link.length > 0 ?
                          <table className="viewSponsorCourseLinks">
                            <thead>
                              <tr>
                                <th style={{ width: "7%" }}>S. NO</th>
                                <th style={{ width: "40%" }}>LINK/URL</th>
                                <th style={{ width: "40%" }}>DESCRIPTION</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                links.slice(offset, appConfig.paginationLimit + offset).map((item, i) => (
                                  <tr>
                                    <td>{i + 1}</td>
                                    <td><a href={item.detail1} target="_blank">{item.detail1.limit(40)}</a></td>
                                    <td>{item.detail2 == ("" || null || undefined) ? '---' : item.detail2.limit(40)}</td>
                                    <td className="filestatus">{item.status == "Y" ? "Active" : "Inactive"}
                                      {
                                        isEditCourse === "1" ?
                                          <FormControlLabel
                                            control={
                                              <Switch
                                                checked={item.status === "Y" ? true : false}
                                                onChange={(e) => statusChange(e, item, i, "link")}
                                                name="checkedB"
                                                color="primary"
                                                size="small"
                                              />
                                            }
                                            // label="Status"
                                            labelPlacement="start"
                                          />
                                          : ""}
                                    </td>
                                  </tr>

                                ))
                              }
                              <tr>
                                <td colSpan="4">
                                  {links.length > appConfig.paginationLimit &&
                                    <Paginationn handlePageClick={handlePageClick} data={links.length} offset={offset} />
                                  }
                                </td>

                              </tr>
                            </tbody>

                          </table>
                          : <div className="nodata">No Data Found</div>}
                      </>
                    </TabContainer>
                    }
                    {value === 1 && <TabContainer>

                      <>
                        {/* <div style={{ fontSize: "14px", fontWeight: "700", color: "#626262", marginLeft: "5px" }}>Documents</div> */}
                        {/* <div className="inputBox"> */}
                        {documents.length > 0 ?
                          <table className="viewSponsorCourseLinks">
                            <thead>
                              <tr>
                                <th style={{ width: "7%" }}>S. NO</th>
                                <th style={{ width: "15%" }}>TYPE</th>
                                <th style={{ width: "38%" }}>NAME</th>
                                <th style={{ width: "20%" }}>PREVIEW</th>
                                <th>STATUS</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                documents.slice(offset, appConfig.paginationLimit + offset).map((item, i) => (
                                  <tr>
                                    <td>{i + 1}</td>
                                    <td>{item.detail3}</td>
                                    <td onClick={(e) => { download(e, item) }} style={{ cursor: "pointer" }}><Tooltip title="Click to download" arrow><a href="#">  {item.detail2}</a></Tooltip></td>
                                    <td className="previewpdf">{item.detail3.includes("image") ? <span onClick={(e) => imgClick(e, item.url)}>{image(item.url)}</span> : item.detail3.includes("pdf") && <span style={{ cursor: "pointer" }} onClick={(e) => pdfClick(e, item.url)}><PdfPreview url={item.url} show={false} width="75" />
                                    </span>}
                                    </td>
                                    <td className="filestatus">{item.status == "Y" ? "Active" : "Inactive"}
                                      {
                                        isEditCourse === "1" ?
                                          <FormControlLabel
                                            control={
                                              <Switch
                                                checked={item.status === "Y" ? true : false}
                                                onChange={(e) => statusChange(e, item, i, "documents")}
                                                name="checkedB"
                                                color="primary"
                                                size="small"
                                              />
                                            }
                                            // label="Status"
                                            labelPlacement="start"
                                          />
                                          : ""}
                                    </td>
                                    <td className="filedetails">
                                      <div
                                        className="fullwidth text-center posrelative"
                                        onMouseEnter={(event) => hoverEnter(event, props.data)}
                                        onMouseLeave={(event) => hoverLeave(event, props.data)}
                                      >
                                        <img src={DotsIcon} alt="click to view" />
                                        <div className="tpopover"
                                          onMouseEnter={(event) => tpopoverEnter(event, props.data)}
                                          onMouseLeave={(event) => tpopoverLeave(event, props.data)}
                                        >
                                          {console.log(item, "item")}
                                          <a onClick={(e) => { download(e, item) }}><img src={Download} alt="" />Download File</a>
                                          {
                                            isEditCourse === "1" ?
                                              <a><img src={Update} alt="" />
                                                <FileUpdate text="File Update" dataToAccept='image/*,.pdf,.xlsx,.txt,.xls,.ppt,.pptx,.doc,.docx' item={item} type="Document" buArea="Notes" buId={noteId} callUpdateApi={callUpdateApi} loading={loading} />
                                              </a> : ""}
                                          {/* <a onClick={(e) => fileversion(e, item, "File Versions")} ><img src={History} alt="" />File Versions</a> */}
                                          <a onClick={(e) => ownerDetailsClick(e, item)} ><img src={User} alt="" />Owner Details</a>
                                          <a onClick={(e) => fileversion(e, item, "File History")} ><img src={History} alt="" />File History</a>



                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              }
                              <tr>
                                <td colSpan="5">
                                  {documents.length > appConfig.paginationLimit &&
                                    <Paginationn handlePageClick={handlePageClick} data={documents.length} offset={offset} />
                                  }
                                </td>
                              </tr>
                            </tbody>
                          </table> : <div className="nodata">No Data Found</div>}

                      </>
                    </TabContainer>
                    }
                    {/* {value === 2 &&
                     <TabContainer>

                      <>
                        
                        {videos.length > 0 ?
                          <table className="viewSponsorCourseLinks">
                            <thead>
                              <tr>
                                <th style={{ width: "7%" }}>S. NO</th>
                                <th style={{ width: "10%" }}>TYPE</th>
                                <th style={{ width: "38%" }}>NAME</th>
                                <th style={{ width: "20%" }}>PREVIEW</th>
                                <th style={{ width: "15%" }}>STATUS</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                videos.slice(offset, appConfig.paginationLimit + offset).map((item, i) => (
                                  <tr>
                                    <td>{i + 1}</td>
                                    <td>{item.detail3}</td>
                                    <td onClick={(e) => { download(e, item) }} style={{ cursor: "pointer" }}><Tooltip title="Click to download" arrow><a href="#">  {item.detail2}</a></Tooltip></td>
                                    <td className="center">
                                      <React.Fragment key={item.url}>
                                        <VideoPlayer videoUrl={item.url} snapshotAt={2} />
                                      </React.Fragment>

                                    </td>
                                    <td className="filestatus">{item.status == "Y" ? "Active" : "Inactive"}
                                      {
                                        isEditCourse === "1" ?

                                          <FormControlLabel
                                            control={
                                              <Switch
                                                checked={item.status === "Y" ? true : false}
                                                onChange={(e) => statusChange(e, item, i, "videos")}
                                                name="checkedB"
                                                color="primary"
                                                size="small"
                                              />
                                            }
                                          
                                            labelPlacement="start"
                                          />
                                          : ""}
                                    </td>
                                    <td className="filedetails">
                                      <div
                                        className="fullwidth text-center posrelative"
                                        onMouseEnter={(event) => hoverEnter(event, props.data)}
                                        onMouseLeave={(event) => hoverLeave(event, props.data)}
                                      >
                                        <img src={DotsIcon} alt="click to view" />
                                        <div className="tpopover"
                                          onMouseEnter={(event) => tpopoverEnter(event, props.data)}
                                          onMouseLeave={(event) => tpopoverLeave(event, props.data)}
                                        >
                                          <a onClick={(e) => { download(e, item) }}><img src={Download} alt="" />Download File</a>
                                          {
                                            isEditCourse === "1" ?
                                              <a><img src={Update} alt="" />
                                                <FileUpdate text="File Update" dataToAccept='video/*' item={item} type="Video" buArea="Resource" buId={ID} callUpdateApi={callUpdateApi} loading={loading} />
                                              </a> : ""}
                                          <a onClick={(e) => ownerDetailsClick(e, item)} ><img src={User} alt="" />Owner Details</a>
                                          <a onClick={(e) => fileversion(e, item, "File History")} ><img src={History} alt="" />File History</a>

                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              }
                              <tr>
                                <td colSpan="5">
                                  {videos.length > appConfig.paginationLimit &&
                                    <Paginationn handlePageClick={handlePageClick} data={videos.length} offset={offset} />
                                  }
                                </td>
                              </tr>
                            </tbody>
                          </table> : <div className="nodata">No Data Found</div>}
                      </>
                    </TabContainer>
                    } */}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateFormField: (obj) => {
      return dispatch(
        {
          type: 'UpdateFormField',
          value: obj.value,
          name: obj.name
        }
      )
    },
    UpdateEntireForm: (obj) => {
      return dispatch(
        {
          type: 'UpdateEntireForm',
          value: obj,
        }
      )
    },
    updateNotesData: (obj) => {
      return dispatch(
        {
          type: 'updateNotesData',
          value: obj,
        }
      )
    },
    clearForm: () => {
      return dispatch(
        {
          type: 'ClearForm',
        }
      )
    },
    updateErrorObj: (obj) => {
      return dispatch(
        {
          type: 'updateErrorObj',
          flag: obj.flag,
          name: obj.name,
          text: obj.text
        }
      )
    },
    updateEntireErrorObj: (errobj, errtextobj) => {
      return dispatch(
        {
          type: 'updateEntireErrorObj',
          errobj: errobj,
          errtextobj: errtextobj,
        }
      )
    },
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewNotes));